const state = {
  enums: {},
  loginStatus: false,
  loginToken: '',

  //sysApi: 'http://127.0.0.1:8823',
  //sysApi: 'http://139.196.220.46:8823',
  sysApi: 'https://wx.api.gymthy.com',
  topMenu:{},
  moduleChildMap:{},
  moduleFuncMap:{},
  funcOperMap:{},
  firstModule:{},
  firstFunc: {},
  defaultFuncId:'',
  funcIdName: 'paasCurrentFunctionId',
  sysUserId:'',

};

export default  state;
